import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table history movement view.
 */
export default class tableHistoryMovementView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        /**
         * Marks the movement type with specific colors.
         * @param {string} value - The movement type.
         * @returns {string} CSS class for the movement type.
         */
        function mark_new(value) {
            if (value == 'Entrada') {
                return 'lightgreen'; // Color for 'Entrada'
            } else {
                if (value == 'Salida') {
                    return 'highlight'; // Color for 'Salida'
                } else {
                    return ''; // Default color
                }
            }
        }

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Column definitions
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                {
                    id: 'UserId',
                    header: _('ID Usuario'), // User ID column with localization
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Movement',
                    header: _('Movimiento'), // Movement column with localization
                    options: [
                        { id: '0', value: _('Entrada') }, // Entry option
                        { id: '1', value: _('Salida') }, // Exit option
                        { id: '2', value: _('Cancelación') }, // Cancellation option
                    ],
                    width: 100,
                    sort: 'int',
                    cssFormat: mark_new, // Apply custom CSS formatting
                },
                { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' }, // Type column
                {
                    id: 'ExternalId',
                    header: _('ID Externo'), // External ID column with localization
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de creación'), // Creation date column with localization
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'Amount',
                    header: _('Valor'), // Amount column with localization
                    width: 100,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                },
                {
                    id: 'BalanceDeposit',
                    header: _('Saldo'), // Balance column with localization
                    width: 100,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                },
            ],
            on: {
                // Event handlers
                onBeforeLoad: function () {
                    this.showOverlay(
                        // Show loading overlay
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            ready: function () {
                if (!this.count()) {
                    // Check if there are no data
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var filter = ''; // Filter string
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url =
            devConfig.geturlApi() + // API URL
            'es/BalanceHistory/GetBalanceMovement?FromId=' +
            cur_user +
            '&';

        // Event listener for filtering data
        this.on(this.app, 'historyMovement:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // End date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data
            $$('filterPopup').hide(); // Hide filter popup
            filter = string1; // Update filter string
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
